import React,  { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import { useForm } from "react-hook-form";
import 'stylesheets/ubold_theme/plugins/_bootstrap-touchspin.scss';

export default function InputCode(props) {

    const codeInputStyle = {
        boxSizing: 'border-box',
        width: 'clamp(40px, 12vw, 52px)',
        height: 'clamp(40px, 12vw, 52px)'
    };

    const { register, trigger,handleSubmit, clearErrors, setError, setValue, formState: { errors, isValid, isSubmitting }, reset} = useForm({ mode: 'onBlur'});
    const [cta, setCta] = useState('Verify');
    const [validCode, setValidCode] = useState(null);
    const [resendStatus, setResendStatus] = useState('Resend');
    const [errorMessage, setErrorMessage] = useState(props.twilioError);
    const [twilioAttempts, setTwilioAttempts] = useState(0);
    const [allowSkip, setAllowSkip] = useState(false);
    const codeRefs = React.useRef([]);
    const allowedInputKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'];

    useEffect(() => {
        if(validCode == false) {
            codeRefs.current[0].children[0].focus();
            reset();
        }
        [...Array(6).keys()].map( (i) => {
            if(validCode == false) setError(`code.${i}`, {message: 'Invalid code'});
            else clearErrors(`code.${i}`)
        })
    }, [validCode]);

    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }

    // Event handlers

    const onResendCode = async() => {
        setResendStatus('Resending...');
        reset();
        setValidCode(null);

        let sendData = { id: props.currentUser?.id, phone: props.currentUser?.phone, authenticity_token: props.token}
        await fetch('/users/send_verification_code', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(sendData)
        }).then(function(response) {
            return response.json();
        }).then(function(jsonResponse) {
            if(jsonResponse.skip_verification === true) {
                setResendStatus('Resend');
                setCta('Onward...');
                setTimeout(() => { props.onNextModal() }, 1000);
            } else if(jsonResponse.success === true) {
                setResendStatus('Code sent!');
                setTimeout(() => { setResendStatus('Resend') }, 1500);
            } else {
                setResendStatus('Error resending. Try again.');
                setTimeout(() => { setResendStatus('Resend') }, 1500);
            }
        });
    }

    const onVerifyCode = async(data) => {
        setCta('Verifying...');
        setTwilioAttempts(twilioAttempts + 1);
        let sendData = { phone: props.currentUser?.phone, authenticity_token: props.token, code:  data.code.join(''), user_id: props.currentUser?.id}

        await fetch('/users/check_verification_code', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(sendData)
        }).then(function(response) {
            return response.json();
        }).then(function(jsonResponse) {
            if(jsonResponse.skip_verification === true) {
                setCta('Onward...');
                setTimeout(() => { props.onNextModal({ redirect_path: jsonResponse?.redirect_path }) }, 1000);
            } else if(jsonResponse.success === true) {
                // VWO goal conversion code
                window._vis_opt_queue = window._vis_opt_queue || [];
                window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(203);});
                setValidCode(true);
                setCta('Success! Onward...');
                setTimeout(() => { props.onNextModal({ redirect_path: jsonResponse?.redirect_path, phoneConfirmed: true }) }, 1500);
            }  else {
                setErrorMessage(jsonResponse?.error);
                setValidCode(false);
                setCta('Verify');
                setAllowSkip(twilioAttempts >= 2);
            }
        });
    }

    function handleNextFocus(index) {
        codeRefs.current[index+1].children[0].focus();
        setValidCode(null);
    }

    const onSkipHandler = () => {
        props.onNextModal({ skip: 1 });
    }

    // Render functions

    const renderCodeValidationResponse = () => {
        if(validCode !== null) {
            return (
                <div className={'position-absolute top-25 start-0 start-sm-5'} style={{left: '5px'}}>
                    <i className={`fas fa-${validCode ? 'check-circle' : 'times-circle'} text-${validCode ? 'success' : 'danger'} fs-6 fs-sm-4 fs-md-3`}></i>
                </div>
            )
        }
    }

    const renderErrorMessage = () => {
        if(errorMessage) {
            return (
                <div className={'px-3 px-sm-5'}>
                    <div className={'mt-4 bg-soft-danger border border-danger text-danger fw-bold rounded p-2'} style={{ fontSize: '12px'}}>
                        {errorMessage}
                    </div>
                </div>
            )
        }
    }

    const renderSkipButton = () => {
        if(allowSkip) {
            return (
                <div className={'text-end mt-3 px-3 px-sm-5'}>
                    <div className={'btn btn-link text-secondary p-0 fw-normal'} onClick={() => onSkipHandler()}>
                        Skip
                    </div>
                </div>
            )
        }
    }

    const renderCodeInputs = () => {
        return (
            [...Array(6).keys()].map( (i) => {
                return (
                    <Form.Group key={i} ref={(el) => codeRefs.current.push(el)}>
                        <Form.Control
                            style={codeInputStyle}
                            className={`fs-3 text-center text-secondary px-0`}
                            type={'number'}
                            maxLength={1}
                            autoFocus={i==0}
                            onFocus={(e) => {
                                e.target.select();
                            }}
                            onInput={(e) => {
                                if(e.target.value.length == 1) handleNextFocus(i);
                            }}
                            onKeyDown={(e) => {
                                let value = e.target.value;
                                if (value.length == 1 && e.key.match(/\d/)) {
                                    e.target.value = e.key;
                                    handleNextFocus(i);
                                }
                                if(value.length == 1 && !allowedInputKeys.includes(e.key))  return e.preventDefault();
                                if (!value && e.key === 'Backspace') codeRefs.current[i-1]?.children[0]?.focus();
                                if (e.key === 'ArrowLeft' && i) {
                                    e.preventDefault();
                                    codeRefs.current[i-1].children[0].focus();
                                }
                                if (e.key === 'ArrowRight') {
                                    e.preventDefault();
                                    codeRefs.current[i+1].children[0].focus();
                                }
                            }}
                            onPaste={(e) => {
                                let pastedData = e.clipboardData.getData('text').trim();
                                let code = pastedData.match(/\d/g);
                                if (code.length < 6) { return e.preventDefault(); }
                                e.preventDefault();
                                [...Array(6).keys()].map( (j) => {
                                    $(codeRefs.current[j].children[0]).val(code[j]);
                                    setValue(`code.${j}`, code[j]);
                                });
                                trigger(); // trigger validation
                            }}
                            {...register(`code.${i}`, {
                                required: true,
                                maxLength: 1,
                                pattern: /\d/
                                })} />
                    </Form.Group>
                )
            })
        )
    }

    const renderSubheader = () => {
        if(props.isLandline) {
            return (
                <>
                    We're calling {props.currentUser?.phone}. Listen to the code and enter it below.
                    To receive it by text, <span role={'button'} className={'fw-bolder'} onClick={(e) => props.onEditPhone(e)}>update to a mobile number.</span>
                </>
            )
        } else {
            return (
                <>
                    We have texted you a code to {props.currentUser?.phone}.
                    <br />
                    Please enter it below. (<span role={'button'} className={'fw-bolder'} onClick={(e) => props.onEditPhone(e)}>edit phone</span>)
                </>
            )
        }
    }

    return (
        <>
            <Modal.Header className={'border-bottom-0 pt-4 pb-0 justify-content-center text-center'}>
                <Modal.Title className={'fs-4 mb-0'}>
                    Fill in your verification code
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className={'text-secondary text-center px-0 pt-0'}>
                <div className={'d-flex align-items-center justify-content-center mb-4 secondary-links fs-6 px-3 px-sm-5'}>
                    <i className={`fal fa-${props.isLandline ? 'phone-arrow-up-right' : 'mobile' } fs-3 text-secondary me-3`}></i>
                    <div className={'text-start'}>{renderSubheader()}</div>
                </div>

                <Form noValidate={true} onSubmit={handleSubmit(onVerifyCode)}>
                    <div className={'code-inputs d-flex justify-content-between position-relative bootstrap-touchspin mx-auto px-3 px-sm-5 w-100 '} style={{width: 'fit-content'}}>
                        {renderCodeValidationResponse()}
                        {renderCodeInputs()}
                    </div>
                    <div className={'pt-1 px-3 px-sm-5'} ref={(el) => codeRefs.current.push(el)}>
                        <Button variant="primary" type="submit" className={'btn-block btn-hover-cursor mt-4'} disabled={!isValid || isSubmitting || validCode}>
                            {cta}
                        </Button>
                    </div>
                </Form>

                <div className={'mt-4 secondary-links fs-6 px-2 px-sm-5'}>
                    Didn't receive your code? <span role={'button'} className={'fw-bolder'} onClick={onResendCode}>{resendStatus}</span>
                </div>

                {renderErrorMessage()}
                {renderSkipButton()}
            </Modal.Body>
        </>
    )
}